import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  DataTable,
  Page,
  Card,
  Text,
  ButtonGroup,
  Button,
  Modal,
  TextField,
  Select,
  BlockStack,
  InlineStack,
  Box,
  Spinner,
  FormLayout,
  Image,
  Link,
  Divider,
  Tag,
  Toast,
  Icon,
  Badge,
  InlineGrid,
  Avatar,
  Grid,
  Thumbnail,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import MyPagination from "@material-ui/lab/Pagination";
import { useNavigate } from "react-router-dom";
import {
  CategoriesIcon,
  ClipboardIcon,
  EditIcon,
  ImagesIcon,
  LinkIcon,
  ListBulletedIcon,
  PlusCircleIcon,
  TeamIcon,
} from "@shopify/polaris-icons";
import countries from "../../Data/countries.json";
import lebanonIcon from "../../Assets/Images/lb.svg";
import iraqIcon from "../../Assets/Images/iq.svg";
import egyptIcon from "../../Assets/Images/eg.svg";

const People = () => {
  const navigate = useNavigate();

  // Filters state
  const [search, setSearch] = useState("");
  const [status, setPriority] = useState("All");
  const [typeFilter, setTypeFilter] = useState("All");
  const [departmentFilter, setDepartmentFilter] = useState("All");
  const [optionsDepartments, setOptionsDepartments] = useState([]);
  const [statusFilter, setPriorityFilter] = useState("All");
  const [countryFilter, setCountryFilter] = useState("");
  const [timeline, setTimeline] = useState("All");
  const timelineButtons = [
    { label: "All", value: "All" },
    { label: "This Week", value: "week" },
    { label: "This Month", value: "month" },
  ];

  // Data state
  const [items, setItems] = useState(null);
  const [result, setResult] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isListEmpty, setIsListEmpty] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const perPage = 50;
  const refBoolPage = useRef(true);
  const [activeShow, setActiveShow] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Toast
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive(!active), []);
  const [toastContent, setToastContent] = useState(
    "This page has been successfully deleted",
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;

  // Modal Delete
  const [activeDelete, setActiveDelete] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const refId = useRef(null);

  const handleChangeModalShow = useCallback(() => {
    setActiveShow(!activeShow);
  }, [activeShow]);

  const handleChangeModalDelete = useCallback(() => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, [activeDelete]);

  const handleRowClick = (index) => {
    // setCurrentIndex(index);
    //setActiveShow(true);
  };

  const handleAddItem = () => {
    navigate("/admin/people/new");
  };

  const handleEdit = (id) => {
    navigate(`/admin/people/${id}`);
  };

  const handleScreenshots = (id) => {
    navigate(`/admin/users/${id}/screenshots`);
  };

  const handleNext = () => {
    if (currentIndex < result.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const [optionsCountries, setOptionsCountries] = useState([]);
  const [country, setCountry] = useState("");

  const [type, setType] = useState("All");
  const typeButtons = [
    { label: "All", value: "All" },
    { label: "Teams", value: "1", icon: TeamIcon },
    { label: "Stakeholders", value: "2", icon: ListBulletedIcon },
  ];

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await axios.get(`/departments?all`);
        const data = response?.data?.data;

        const options = [
          { label: "All", value: "All" },
          ...data.map((dept) => ({
            label: dept.name,
            value: dept.id,
          })),
        ];

        setOptionsDepartments(options);
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    };

    fetchDepartments();
  }, []);

  // Fetch data from API with filters
  useEffect(() => {
    fetchData();
  }, [
    page,
    search,
    type,
    countryFilter,
    statusFilter,
    country,
    departmentFilter,
  ]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("per_page", perPage);
      params.append("page", refBoolPage.current ? page : 1);
      if (search) params.append("filter[name]", search);
      if (type !== "All") params.append("filter[type]", type);
      if (statusFilter !== "All") params.append("filter[status]", statusFilter);
      if (departmentFilter !== "All")
        params.append("filter[department_id]", departmentFilter);
      if (country !== "") params.append("filter[country]", country);
      // if (statusFilter !== "All") params.append("filter[type]", typeFilter);
      // if (countryFilter !== "All")
      //   params.append("filter[location]", countryFilter);

      const response = await axios.get(`/people`, { params });
      const data = response.data.data.data;

      console.log("data=", data);
      setResult(data);
      setItems(
        data.map((item, index) => [
          <div
            className="border border-light rounded overflow-hidden row_click2"
            style={{ width: "100px", height: "50px" }}
            onClick={() => handleRowClick(index)}
          >
            <img
              src={
                item.image_url ||
                "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png"
              }
              alt="image"
              className="img-fluid w-100 h-100"
              style={{ objectFit: "contain" }}
            />
          </div>,
          <div onClick={() => handleRowClick(index)} className="row_click2">
            {item.name || "-"}
          </div>,
          <div onClick={() => handleRowClick(index)} className="row_click2">
            {item.person_role || "-"}
          </div>,
          <div onClick={() => handleRowClick(index)} className="row_click2">
            {item.department?.name || "-"}
          </div>,
          <div onClick={() => handleRowClick(index)} className="row_click2">
            {item.email || "-"}
          </div>,
          // <div onClick={() => handleRowClick(index)} className="row_click2">
          //   <Badge tone={item.status?.id === 2 ? "success" : "default"}>
          //     {item.status?.description || "-"}
          //   </Badge>
          // </div>,

          <div className="me-3">
            <ButtonGroup>
              {/* <Button
                onClick={() => handleScreenshots(item.id)}
                icon={ImagesIcon}
              >
                Screenshots
              </Button> */}
              <Button onClick={() => handleEdit(item.id)} icon={EditIcon}>
                Edit
              </Button>
            </ButtonGroup>
          </div>,
        ]),
      );

      setTotalPages(response.data.data.total);
      setIsListEmpty(!data.length);
    } catch (err) {
      console.error(err);
      setIsListEmpty(true);
    }
    setIsLoading(false);
  };

  const emtyState = isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <img src={emptyListImage} />
      </div>
      <div className="mb-3">
        <Text variant="headingLg" as="h5" color="subdued">
          No results found
        </Text>
      </div>
    </div>
  ) : isLoading ? (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  ) : null;
  const [view, setView] = useState("list");

  const toggleView = () => {
    setView(view === "table" ? "list" : "table");
  };
  const [countryButtons, setCountryButtons] = useState([]);
  const [departmentButtons, setDepartmentButtons] = useState([]);

  useEffect(() => {
    axios
      .get("/settings/countries")
      .then((res) => {
        const countriesData = res?.data?.data || [];
        const options = [
          { label: "All", value: "" },
          { label: "Mutual", value: "All" },
          ...countriesData.map((country) => ({
            label: country.name,
            value: country.name,
            flag: country.flag,
          })),
        ];
        setCountryButtons(options);
        // setCountry(options?.[0]);
      })
      .catch((err) => console.log(err));
  }, []);
  const [copyToastActive, setCopyToastActive] = useState(false);
  const [copyToastContent, setCopyToastContent] = useState("");
  const toggleCopyToast = useCallback(
    () => setCopyToastActive((prev) => !prev),
    [],
  );
  const copyToastMarkup = copyToastActive ? (
    <Toast content={copyToastContent} onDismiss={toggleCopyToast} />
  ) : null;

  return items ? (
    <Page
      title="People"
      primaryAction={
        <Button variant="primary" onClick={handleAddItem} icon={PlusCircleIcon}>
          Add User
        </Button>
      }
      secondaryActions={
        <ButtonGroup>
          {/* <Button icon={CategoriesIcon}></Button>
          <Button icon={ListBulletedIcon}></Button> */}
          <Button
            onClick={toggleView}
            icon={view === "table" ? CategoriesIcon : ListBulletedIcon}
          >
            {view === "table" ? "List View" : "Table View"}
          </Button>
          {/* <Button onClick={() => navigate("/admin/people/edit/departments")}>
            Departments
          </Button> */}
        </ButtonGroup>
      }
      fullWidth
    >
      {/* Filters Card */}
      <FormLayout>
        <Card>
          <BlockStack gap="500">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center", // ✅ keeps both sides aligned vertically
                flexWrap: "wrap",
                gap: "1rem",
                rowGap: "1.5rem",
              }}
            >
              {/* 🔹 Left side: Filters + Timeline buttons */}
              <FormLayout>
                <InlineStack gap="300" wrap align="center">
                  <Box minWidth="260px">
                    <TextField
                      label="Search users"
                      value={search}
                      onChange={setSearch}
                      autoComplete="off"
                      placeholder="Search by name"
                    />
                  </Box>

                  {/* <Select
                  label="Department"
                  value={departmentFilter}
                  onChange={setDepartmentFilter}
                  options={optionsDepartments}
                /> */}
                  <Select
                    label="Status"
                    value={statusFilter}
                    onChange={setPriorityFilter}
                    options={[
                      { label: "All", value: "All" },
                      { label: "Active", value: "2" },
                      { label: "Pending", value: "1" },
                    ]}
                  />
                  <Select
                    label="Type"
                    value={type}
                    onChange={setType}
                    options={[
                      { label: "All", value: "All" },
                      { label: "Teams", value: "1", icon: TeamIcon },
                      {
                        label: "Stakeholders",
                        value: "2",
                        icon: ListBulletedIcon,
                      },
                    ]}
                  />
                </InlineStack>
              </FormLayout>

              {/* 🔹 Right side: Country buttons */}
              <Box display="flex" alignItems="center">
                <ButtonGroup segmented>
                  {countryButtons.map((t) => (
                    <Button
                      key={t.value}
                      pressed={String(country) === String(t.value)}
                      onClick={() => setCountry(String(t.value))}
                    >
                      {t.flag && (
                        <img
                          src={t.flag}
                          alt={t.flag}
                          style={{ width: 20, marginRight: 6 }}
                        />
                      )}
                      {t.label}
                    </Button>
                  ))}
                </ButtonGroup>
              </Box>
            </div>
          </BlockStack>
        </Card>
        <Card>
          <InlineStack align="start">
            <ButtonGroup segmented>
              {optionsDepartments.map((t) => (
                <Button
                  key={t.value}
                  pressed={String(departmentFilter) === String(t.value)}
                  onClick={() => setDepartmentFilter(String(t.value))}
                >
                  {t.label}
                </Button>
              ))}
            </ButtonGroup>
          </InlineStack>
        </Card>

        {/* DataTable */}
        {items?.length ? (
          // <Card padding="0">
          view === "table" ? (
            <Card padding={0}>
              <DataTable
                columnContentTypes={["text", "text", "text", "text"]}
                headings={[
                  "Image",
                  "Name",
                  "Role",
                  "Department",
                  "Email",
                  // "Status",
                  "",
                ]}
                rows={items}
                verticalAlign="middle"
                stickyHeader
                footerContent={
                  items?.length &&
                  `Showing ${items.length} of ${totalPages} results`
                }
              />
            </Card>
          ) : (
            <Grid>
              {result.map((user) => (
                <Grid.Cell
                  key={user.id}
                  columnSpan={{ xs: 6, sm: 3, md: 3, lg: 4, xl: 3 }}
                >
                  <Card>
                    <div
                      style={{
                        position: "relative",
                        paddingRight: "2rem",
                        height: 100, // ✅ fixed card height (adjust)
                        display: "flex", // ✅ helps vertical alignment
                        alignItems: "center", // ✅ keep content centered vertically
                        width: "100%", // ✅ fill column width
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "-8px", // ✅ moves the edit icon higher
                          right: "8px",
                          borderRadius: "50%",
                          padding: "4px",
                          zIndex: 1,
                        }}
                      >
                        {/* 🖊️ Edit button INSIDE the card */}
                        <Button
                          variant="plain"
                          icon={EditIcon}
                          accessibilityLabel="Edit user"
                          onClick={() => handleEdit(user.id)}
                        />
                      </div>

                      {/* 👇 your content */}
                      <InlineStack gap="400" align="start" blockAlign="center">
                        <Box
                          style={{
                            flex: "0 0 80px",
                            height: "80px",
                            overflow: "hidden",
                            borderRadius: "8%",
                          }}
                        >
                          <img
                            src={user.image_url}
                            alt={user.name}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        </Box>
                        {/* <Thumbnail
                          customer
                          size="large"
                          name={user.name}
                          source={user.image_url}
                        /> */}
                        <Box style={{ flex: "1 1 0", minWidth: 0 }}>
                          <BlockStack gap="100">
                            <Text
                              as="h3"
                              variant="bodyMd"
                              fontWeight="semibold"
                            >
                              {user.name}
                            </Text>
                            <Text as="p" variant="bodySm" tone="subdued">
                              {user.person_role || ""}
                            </Text>
                            {/* 📋 Email with copy button */}
                            <InlineStack gap="200" align="left">
                              <Text as="p" variant="bodySm" tone="subdued">
                                {user.email}
                              </Text>
                              <Button
                                variant="plain"
                                icon={ClipboardIcon}
                                accessibilityLabel="Copy email"
                                onClick={() => {
                                  navigator.clipboard.writeText(user.email);
                                  setCopyToastContent(
                                    `Email copied: ${user.email}`,
                                  );
                                  setCopyToastActive(true);
                                }}
                              />
                            </InlineStack>

                            <InlineStack gap="200">
                              <Badge>{user.department?.name || ""}</Badge>
                              {/* <Badge
                              tone={
                                user.status.id === 2 ? "success" : "critical"
                              }
                            >
                              {user.status.description}
                            </Badge> */}
                            </InlineStack>
                          </BlockStack>
                        </Box>
                      </InlineStack>
                    </div>
                  </Card>
                </Grid.Cell>
              ))}
            </Grid>
            // <InlineGrid gap="4" columns={{ xs: 1, sm: 2, md: 3 }}>
            //   {result.map((item) => (
            //     <Card roundedAbove="sm">
            //       <InlineStack gap="400" align="start" blockAlign="center">
            //         {/* Avatar */}
            //         <Avatar
            //           customer
            //           size="medium"
            //           name="Marcus Williams"
            //           source="https://via.placeholder.com/64" // Replace with actual image URL
            //         />

            //         {/* Info section */}
            //         <BlockStack gap="200">
            //           <Text as="h3" variant="bodyMd" fontWeight="semibold">
            //             Marcus Williams
            //           </Text>
            //           <Text as="p" variant="bodySm" tone="subdued">
            //             marcus.w@company.com
            //           </Text>

            //           {/* Badges */}
            //           <InlineStack gap="200">
            //             <Badge tone="attention">Engineering Lead</Badge>
            //             <Badge tone="success">active</Badge>
            //           </InlineStack>

            //           <Text as="p" variant="bodySm" tone="subdued">
            //             Engineering
            //           </Text>
            //         </BlockStack>
            //       </InlineStack>
            //     </Card>
            //   ))}
            // </InlineGrid>
          )
        ) : (
          // </Card>
          <Card>
            <div
              style={{
                display: "flex",
                justifyContent: "middle",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div style={{ width: "25%" }}>
                <img src={emptyListImage}></img>
              </div>
              <div className="mb-3">
                <Text variant="headingLg" as="h5" color="subdued">
                  No results found
                </Text>
              </div>
              <br />
            </div>
          </Card>
        )}

        {/* Pagination */}
        {Math.ceil(totalPages / perPage) >= 2 && (
          <div
            style={{
              paddingTop: "10px",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <MyPagination
              count={Math.ceil(totalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            />
          </div>
        )}
      </FormLayout>
      {/* Modals */}
      {/* <Modal
        open={activeShow}
        onClose={handleChangeModalShow}
        title={result?.[currentIndex]?.business_name ?? ""}
        primaryAction={{
          content: "Next",
          onAction: handleNext,
          disabled: currentIndex === result?.length - 1,
        }}
        secondaryActions={[
          {
            content: "Previous",
            onAction: handlePrevious,
            disabled: currentIndex === 0,
          },
        ]}
      >
        <Modal.Section>
          <div className="fixedModalContent">
            <FormLayout>
              {result?.[currentIndex]?.name ? (
                <FormLayout>
                  <Text as="p" fontWeight="semibold">
                    Name
                  </Text>
                  <Text>{result?.[currentIndex]?.name}</Text>
                  <Divider borderColor="border" />
                </FormLayout>
              ) : null}
              {result?.[currentIndex]?.email ? (
                <FormLayout>
                  <Text as="p" fontWeight="semibold">
                    Email
                  </Text>
                  <Text>{result?.[currentIndex]?.email}</Text>
                  <Divider borderColor="border" />
                </FormLayout>
              ) : null}
              {result?.[currentIndex]?.department ? (
                <FormLayout>
                  <Text as="p" fontWeight="semibold">
                    Department
                  </Text>
                  <Text>{result?.[currentIndex]?.department?.name}</Text>
                  <Divider borderColor="border" />
                </FormLayout>
              ) : null}
              {result?.[currentIndex]?.person_role ? (
                <FormLayout>
                  <Text as="p" fontWeight="semibold">
                    Role
                  </Text>
                  <Text>{result?.[currentIndex]?.person_role}</Text>
                  <Divider borderColor="border" />
                </FormLayout>
              ) : null}
            </FormLayout>
          </div>
        </Modal.Section>
      </Modal> */}
      {copyToastMarkup}
      {toastMarkup}
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
};

export default People;
